import React, {ReactElement} from 'react';
import locationIconSrc from '@assets/images/medops/location2.svg';

const LocationIcon = (props: any): ReactElement => {
  return <img src={locationIconSrc} {...props} />;
};
export default LocationIcon;
